<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { App as CapApp } from '@capacitor/app';
import { useAuthStore } from '@/stores/auth';
import { useUiStore } from '@/stores/ui';
import { useTasksStore } from '@/stores/tasks';
import { useMembersStore } from '@/stores/members';
import { isNative } from '@/services/platform';
import ToastHost from '@/components/common/ToastHost.vue';

const auth = useAuthStore();
const ui = useUiStore();

// child-режим следует за ролью пользователя
watch(
  () => auth.isChild,
  (v) => ui.setChildMode(v),
  { immediate: true },
);

// после входа — поднять данные
watch(
  () => auth.isAuthenticated,
  (v) => {
    if (v) {
      void useTasksStore().bootstrap();
      void useMembersStore().load();
    } else useTasksStore().reset();
  },
);

onMounted(() => {
  if (isNative()) {
    // device-lock при возврате из фона (§4.3)
    void CapApp.addListener('resume', () => auth.lock());
  }
});
</script>

<template>
  <RouterView />
  <ToastHost />
</template>
